import React from 'react';
import { TasksHeader, TasksBody } from '../Component';

function Tasks() {
  return (
    <>
      <TasksHeader />
      <TasksBody />
    </>
  );
}

export default Tasks;
